import React from 'react';
import { Section } from './Shared';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Pensé que mis semanas estaban completas hasta que Solución a Pensión auditó mi PDF. Encontraron 140 semanas de una empresa de construcción donde trabajé en los años 90 que no aparecían en ningún reporte. Solo con eso, mi proyección de mesada subió considerablemente.',
    name: 'Ricardo M.',
    location: 'Bogotá',
    role: 'Constructor independiente, 57 años'
  }, {
    quote: 'Como gerente me aterraba la caída de ingresos al jubilarme. El diagnóstico me mostró exactamente cuánto necesito ahorrar por fuera para no perder mi estilo de vida. Pagué el servicio y el valor que recibí fue incomparable.',
    name: 'Claudia H.',
    location: 'Medellín',
    role: 'Gerente comercial, 48 años'
  }, {
    quote: 'Llevaba años evitando pensar en mi pensión porque el tema me generaba ansiedad. Recibí un audio de 3 minutos y un informe escrito que me explicó todo en términos que por fin entendí. Por primera vez en mi vida laboral sé exactamente dónde estoy y qué debo hacer.',
    name: 'Jorge A.',
    location: 'Cali',
    role: 'Docente universitario, 54 años'
  }];
  return <Section bg="white" data-id="element-186">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-187">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-188">
          Lo que dicen quienes ya conocen su número real.
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-189">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 relative" data-id="element-190">
            <Quote className="w-10 h-10 text-slate-200 absolute top-6 right-6" data-id="element-191" />
            <p className="text-slate-700 italic mb-8 relative z-10" data-id="element-192">
              "{testimonial.quote}"
            </p>
            <div data-id="element-193">
              <p className="font-bold text-slate-900" data-id="element-194">
                {testimonial.name} | {testimonial.location}
              </p>
              <p className="text-sm text-slate-500" data-id="element-195">{testimonial.role}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}